import { render, staticRenderFns } from "./Requirements.vue?vue&type=template&id=240f5e0f&scoped=true"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"
import style0 from "./Requirements.vue?vue&type=style&index=0&id=240f5e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f5e0f",
  null
  
)

export default component.exports